import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper";

function grid(p){
  const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
  p.push();
  p.stroke(...GRID_COLOR);
  p.strokeWeight(1);
  let step = 40; // Size of grid squares

  // Draw grid much larger than canvas so it doesn't "run out" during camera movement
  let gridSize = 2000;
  for (let x = -gridSize; x <= gridSize; x += step) {
      p.line(x, -gridSize, x, gridSize);
  }
  for (let y = -gridSize; y <= gridSize; y += step) {
      p.line(-gridSize, y, gridSize, y);
  }
  p.pop();
}

export const Lovegrowbygiving = ({ p5ref, wt, ht,scale , fs, bgcolor}) => {
  const sketch = (p) => {
    // --- Color definitions ---
    const BLACK = [51, 51, 51];
    const PINK = [235, 93, 123];
    const BEIGE = [255, 254, 246];

    let firstText = "Love grows by giving.";
    let secondText = "";
    let latoFont = "Lato";
    let feelWidths = [];
    let doWidths = [];
    let spaceKerning = 4.75;

    // --- Circle & nutrient particles ---
    let circleSize = 50;
    let circleGrow = 4;
    let particles = [];
    let maxSpeed = 10;
    let spawnInterval = 10;
    let frameCounter = 0;

    const letter_extra_space = {
      a: 1.05, b: 1, c: 1, d: 1, e: 1.5, f: 0, g: 1, h: 1, i: 1, j: 1,
      k: 1, l: 0.1, m: 1, n: 1, o: 1, p: 1, q: 1, r: -0.2, s: 2, t: 0,
      u: 1, v: 0, w: 0, x: 1, y: 1, z: 1,
      A: 1, B: 1, C: 1, D: 1, E: 1, F: 1, G: 1, H: 1, I: 1, J: 1,
      K: 1, L: 0.5, M: 1, N: 1, O: 1, P: 1, Q: 1, R: 1, S: 1, T: 1,
      U: 1, V: 1, W: 1, X: 1, Y: 1, Z: 1,
    };

    function loadGoogleFont() {
      const link = document.createElement("link");
      link.href = "https://fonts.googleapis.com/css2?family=Lato&display=swap";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }

    // --- FIXED CLASS ---
    class NutrientCircle {
      constructor(origin) {
        this.s = p.random(10, 20);
        this.pos = origin.copy();
        this.speed = p.random(1, maxSpeed);

        let angle = p.random(p.TWO_PI);
        this.vel = p.createVector(p.cos(angle), p.sin(angle)).mult(this.speed);

        this.noiseOffsetX = p.random(1000);
        this.noiseOffsetY = p.random(1000);

        this.lifespan = 255;
        this.fadeRate = p.random(2, 5);
      }

      moveOutward() {
        this.pos.add(this.vel);
        this.pos.x += p.map(p.noise(this.noiseOffsetX), 0, 1, -0.5, 0.5);
        this.pos.y += p.map(p.noise(this.noiseOffsetY), 0, 1, -0.5, 0.5);

        this.noiseOffsetX += 0.01;
        this.noiseOffsetY += 0.01;

        this.lifespan -= this.fadeRate;
      }

      show() {
        // let c = p.color(PINK[0], PINK[1], PINK[2], this.lifespan);
        p.fill(PINK);
        p.stroke(PINK);
        p.strokeWeight(1);
        p.ellipse(this.pos.x, this.pos.y, this.s, this.s);
      }
    }

    // ----------- CIRCLE SHAPE (replaces heart) -----------
    const drawCircleShape = (x, y, s) => {
      let maxSize = 250;
      s = p.min(s, maxSize);

      p.push();
      p.noFill();
      p.stroke(PINK);
      p.fill(PINK);
      p.strokeWeight(2);
      p.ellipse(x, y, s, s);
      p.pop();
    };

    const drawWavyCircle = (x, y, s, t) => {
      p.push();
      p.noFill();
      p.stroke(PINK);
      p.strokeWeight(2);
    
      const baseR = s / 2;          // base radius
      const waveAmp = 12;           // how strong the waves are
      const waveFreq = 6;           // number of waves around the circle
    
      p.beginShape();
      for (let a = 0; a < p.TWO_PI; a += 0.02) {
        // wavy radius
        let r = baseR + p.sin(a * waveFreq + t * 2) * waveAmp;
    
        let px = x + r * p.cos(a);
        let py = y + r * p.sin(a);
        p.vertex(px, py);
      }
      p.endShape(p.CLOSE);
    
      p.pop();
    };

    const drawShakyCircle = (x, y, s, t) => {
      p.push();
      p.noFill();
      p.stroke(PINK);
      p.strokeWeight(2);
    
      const radius = s / 2;
      const jitter = 3;  // how shaky the line is (increase for more shake)
    
      p.beginShape();
      for (let a = 0; a < p.TWO_PI; a += 0.05) {
        // normal circle position
        let px = x + radius * p.cos(a);
        let py = y + radius * p.sin(a);
    
        // add shaking
        px += p.random(-jitter, jitter);
        py += p.random(-jitter, jitter);
    
        p.vertex(px, py);
      }
      p.endShape(p.CLOSE);
    
      p.pop();
    };

    const drawNoiseCircle = (x, y, size, t) => {
      p.push();
      p.translate(x, y);
    
      let radius = size / 2;
      let points = 200;        // smoothness of circle
      let noiseScale = 0.8;    // spatial noise frequency
      let noiseAmp = 20;       // how wavy the circle is
      let noiseSpeed = 0.01;   // animation speed
    
      p.noFill();
      p.stroke(PINK);
      p.strokeWeight(3);
    
      p.beginShape();
      for (let i = 0; i < points; i++) {
        let theta = p.map(i, 0, points, 0, p.TWO_PI);
    
        // Perlin noise (organic wobble)
        let nx = Math.cos(theta) * noiseScale;
        let ny = Math.sin(theta) * noiseScale;
        let noiseVal = p.noise(nx, ny, t * noiseSpeed);
    
        let r = radius + (noiseVal - 0.5) * noiseAmp;
        let px = r * Math.cos(theta);
        let py = r * Math.sin(theta);
    
        p.vertex(px, py);
      }
      p.endShape(p.CLOSE);
    
      p.pop();
    };
    
    
    // ------------------------------------------------------

    p.setup = () => {
      loadGoogleFont();
      p.createCanvas(wt, ht);

      p.rectMode(p.CENTER);
      p.ellipseMode(p.CENTER);
      p.textAlign(p.LEFT, p.CENTER);
      p.textSize(fs);
      p.textFont(latoFont);

      // Precompute text width
      for (let i = 0; i < firstText.length; i++) {
        let extra =
          firstText[i] === " "
            ? spaceKerning
            : letter_extra_space[firstText[i]] || 0;
        feelWidths[i] = p.textWidth(firstText[i]) + extra;
      }
      for (let i = 0; i < secondText.length; i++) {
        let extra =
          secondText[i] === " "
            ? spaceKerning
            : letter_extra_space[secondText[i]] || 0;
        doWidths[i] = p.textWidth(secondText[i]) + extra;
      }
    };

    const statictext = () => {
      p.push();
      p.textSize(fs);
      p.textFont(latoFont);
      p.textAlign(p.LEFT, p.CENTER);
      p.fill(BLACK);

      let cx = p.width / 2;
      let firstY = p.height - 120;
      let secondY = firstY + 24;

      let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
      let secondWidth = doWidths.reduce((a, b) => a + b, 0);

      let x = cx - firstWidth / 2;
      for (let i = 0; i < firstText.length; i++) {
        p.text(firstText[i], x, firstY);
        x += feelWidths[i];
      }

      x = cx - secondWidth / 2;
      for (let i = 0; i < secondText.length; i++) {
        p.text(secondText[i], x, secondY);
        x += doWidths[i];
      }

      p.pop();
    };

    const maincontent = () => {
      p.push();
      frameCounter++;

      let center = p.createVector(p.width / 2, p.height / 2);
      // let center = p.translate(p.width / 2, p.height / 2.25);

      // Spawn new particles
      if (frameCounter % spawnInterval === 0) {
        particles.push(new NutrientCircle(center));
        circleSize += circleGrow;
      }

      // Update particles
      for (let i = particles.length - 1; i >= 0; i--) {
        particles[i].moveOutward();
        particles[i].show();

        if (
          particles[i].pos.x < -50 ||
          particles[i].pos.x > p.width + 50 ||
          particles[i].pos.y < -50 ||
          particles[i].pos.y > p.height + 50 ||
          particles[i].lifespan <= 0
        ) {
          particles.splice(i, 1);
        }
      }

      // Draw the circle
      drawCircleShape(center.x, center.y, circleSize);
      // drawWavyCircle(center.x, center.y, circleSize, p.frameCount * 0.02);
      // drawNoiseCircle(center.x, center.y, circleSize, p.frameCount * 0.02);



      p.pop();
    };

    p.draw = () => {
      p.background(BEIGE);
      grid(p);
      maincontent();
      statictext();
    };
  };

  return (
    <div style={{ backgroundColor: bgcolor }}>
      <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
        <ReactP5Wrapper sketch={sketch} />
      </div>
    </div>
  );
};

export default Lovegrowbygiving;
